var __WEBPACK_NAMESPACE_OBJECT__ = require("@fortawesome/free-brands-svg-icons");